module.exports = {
    theme: {
        extend: {
            screens:{
                'xs': { max:'639px' }
            },
            colors: {
                palette: {
                    green: {
                        '50':  '#fafaf3',
                        '100': '#f9f9d6',
                        '200': '#f3f290',
                        '300': '#e8e546',
                        '400': '#cccc14',
                        '500': '#a8b006',
                        '600': '#8e9c00',
                        '700': '#616d06',
                        '800': '#49510a',
                        '900': '#383f0b',
                    },
                    gray: '#AFA8A3',
                    lightgray: '#F7F6F6',
                    greyish: '#7E746D',
                    brown: '#64564C',
                }
            },
            zIndex: {
                '-10': -10,
                '-20': -20,
            },
            opacity: {
                '5': '.05',
                '60': '.6',
                '80': '.8',
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
        // Added extra spacing, for extra margins.
        spacing: {
            px: '1px',
            '0': '0',
            '1': '0.25rem',
            '2': '0.5rem',
            '3': '0.75rem',
            '4': '1rem',
            '5': '1.25rem',
            '6': '1.5rem',
            '7': '1.75rem',
            '8': '2rem',
            '9': '2.25rem',
            '10': '2.5rem',
            '11': '2.75rem',
            '12': '3rem',
            '13': '3.25rem',
            '14': '3.5rem',
            '16': '4rem',
            '18': '4.5rem',
            '20': '5rem',
            '21': '5.25rem',
            '22': '5.5rem',
            '24': '6rem',
            '25': '6.25rem',
            '26': '6.5rem',
            '27': '6.75rem',
            '28': '7rem',
            '32': '8rem',
            '36': '9rem',
            '40': '10rem',
            '42': '10.5rem',
            '44': '11rem',
            '48': '12rem',
            '52': '11rem',
            '56': '14rem',
            '60': '15rem',
            '64': '16rem',
            '68': '17rem',
            '72': '18rem',
            '76': '19rem',
            '80': '20rem',
            '84': '21rem',
            '88': '22rem',
            '92': '23rem',
            '96': '24rem',
            '100': '25rem',
            '1/2': '50%',
            '1/3': '33.333333%',
            '2/3': '33.666667%',
            '1/4': '25%',
            '2/4': '50%',
            '3/4': '75%',
            '1/5': '20%',
            '2/5': '40%',
            '3/5': '60%',
            '4/5': '80%',
            '1/6': '16.666667%',
            '2/6': '33.333333%',
            '3/6': '50%',
            '4/6': '66.666667%',
            '5/6': '83.333333%',
            '16/9': '56.25%',
            '40vh': '40vh',
            '60vh': '60vh',
            '75vh': '75vh',
            'full': '100%',
        },
    },
    variants: {},
    plugins: [
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
